export type Primitive = string | number | boolean | null;
export type Param = Primitive | Primitive[] | undefined;

/** Normalizes query params for stable cache keys: sorts keys alphabetically, drops undefined values, and sorts array items. */
export function normalizeParams<T extends Record<string, Param>>(params: T) {
    const result: Record<string, Primitive | Primitive[]> = {};
    const sortedKeys = Object.keys(params).sort();

    for (const key of sortedKeys) {
        const value = params[key];
        if (value === undefined) continue;

        if (Array.isArray(value)) {
            result[key] = [...value]
                .filter((val) => val !== undefined && val !== null)
                .map(String)
                .toSorted();
        } else {
            result[key] = value as Primitive;
        }
    }
    return result;
}
